<template>
  <div class="t1">
    <site ref="wbsite"></site>
    <nav_list theme="dark"></nav_list>

    <div class="t2">
      <div class="zzc1">
    

        <div class="p3">
          <div class="ll1">
            <div class="li1_tit">
              <span>{{ this.$lang('37406') }}</span>
            </div>
            <div class="rad">
              <el-radio-group v-model="map.time_division_type">
                <el-radio class="radio" :value="0" :label="0"> 
                  <span class="span1">{{ this.$lang('37407') }}</span>
                </el-radio>
                <el-radio class="radio" value="day" label="day">
                  <span class="span1">{{ this.$lang('37408') }}</span>
                </el-radio>
                <el-radio class="radio" value="night" label="night">
                  <span class="span1">{{ this.$lang('37409') }}</span>
                </el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>

        <div class="p2">
          <div class="l1 l100">
            <div class="tit"> {{this.$lang('37401')}}</div>
            <div class="ttt2">
              <el-cascader class="ipt" v-model="map.start_id" :placeholder="this.$lang('37403')" :options="options"
                filterable @change="start_change"></el-cascader>
              
            </div>
          </div>
          <div class="switch-icon" @click="switch_se">
                <img src="~@/../static/changee.png" alt="交换" title="交换出发地和目的地" />
              </div>

          <div class="l1 l101">
            <div class="tit"> {{this.$lang('37411')}}</div>
            <div class="ttt2">
              <el-cascader class="ipt" v-model="map.end_id" :placeholder="this.$lang('37404')" :options="options"
                filterable  @change="end_change" ></el-cascader>

            </div>
          </div>

          <div class="l1 llxx">
            <div class="tit">{{this.$lang('37402')}}</div>
            <div class="ttt2">
              <el-date-picker class="ipt" v-model="map.date" value-format="yyyy-MM-dd" align="right" type="date"
                :placeholder="this.$lang('37405')" :picker-options="pickerOptions"> </el-date-picker>

            </div>
          </div>

          <div class="llzz" >
            <div class="zdzxxzcxz" @click="to_search">
              

              <span class="soc"> {{ this.$lang('37412') }} </span>
            </div>





          </div>
        </div>


        <div class="sybt">
          {{this.$lang('37410')}}
        </div>
        <div class="p4">

          <div class="p4_list" v-for="(itm, i) in re" :key="i" @click="set_re(i)">
            <i class="el-icon-s-promotion"></i>
            {{city_dis(itm.strs.start)}} — {{city_dis(itm.strs.end)}}
          </div>



        </div>

      </div>
    </div>

    <div class="t3">


      <div class="tt3" v-for="(itm,i) in adv" :key="i">
        <div class="j1" @click="jump(itm.uni_url)">
          <div>
            <img :src="itm.paths.cover" alt="" />
          </div>
          <div class="txt">
            <span>{{ itm.paths.title}}</span>
          </div>
        </div>
      </div>

    </div>

 
    
    <div class="hotzz zcxzcxz" >
      <div class="inner">
        
          <div class="line-title">
            <div class="title-container">
              <div class="chinese-title">热门专线</div>
              <div class="english-title">popular train route</div>
            </div>
          </div>

        <div class="hist">
          <div :class="`qow qow-${i}`" v-for="(vo, i) in hot" :key="i"
          :style="`background-image:url(${vo.cover})`"
          @click="jump('/hot/index?curr=' + i)"
          >
            <div class="top">
              <div class="start">
                {{ vo.start }}
              </div>
              <div class="mmd">
                <div class="zwf">
                  {{ vo.time }}
                </div>

                <img src="~@/../static/v3/rjt.png" />
             
              </div>
              <div class="end">
                {{ vo.end }}
              </div>
            </div>
            <div class="bott">
                 
                   {{ vo.tag }}
                
            </div>

           
          </div>
        </div>
      </div>
    </div>

    <div class="shop-home-block shop-home-block--hero" v-if="bannerProducts.length">
      <div class="shop-home-inner">
        <div class="line-title">
          <div class="title-container">
            <div class="chinese-title">景点门票</div>
            <div class="english-title">SCENIC PICKS</div>
          </div>
          <div class="shop-more" @click="jump('/shop')">更多票券</div>
        </div>

        <div class="ticket-grid">
          <div
            class="ticket-card"
            v-for="item in bannerProducts"
            :key="'banner-' + item.id"
            @click="jump('/shop/info?prod_no=' + item.prod_no)"
          >
            <div class="ticket-media">
              <img :src="getShopCover(item)" :alt="item.prod_name">
              <div class="ticket-badge">{{ getCategoryTitle(item) || '景点门票' }}</div>
            </div>
            <div class="ticket-body">
              <div class="ticket-title">{{ item.prod_name }}</div>
              <div class="ticket-desc">{{ getShopSummary(item) }}</div>
              <div class="ticket-foot">
                <span class="ticket-tag">{{ getLocationLabel(item) }}</span>
                <strong class="ticket-price">{{ formatShopPrice(item) }}</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="shop-home-block shop-home-block--shelf" v-if="recommendProducts.length">
      <div class="shop-home-inner">
        <div class="line-title">
          <div class="title-container">
            <div class="chinese-title">推荐商品</div>
            <div class="english-title">CURATED GOODS</div>
          </div>
          <div class="shop-more" @click="jump('/shop')">进入购票页</div>
        </div>

        <div class="goods-shelf">
          <div
            class="goods-card"
            v-for="item in recommendProducts"
            :key="'goods-' + item.id"
            @click="jump('/shop/info?prod_no=' + item.prod_no)"
          >
            <div class="goods-cover">
              <img :src="getShopCover(item)" :alt="item.prod_name">
            </div>
            <div class="goods-copy">
              <div class="goods-topline">
                <span class="goods-category">{{ getCategoryTitle(item) || '精选商品' }}</span>
                <span class="goods-price">{{ formatShopPrice(item) }}</span>
              </div>
              <div class="goods-title">{{ item.prod_name }}</div>
              <div class="goods-summary">{{ getShopSummary(item) }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="t4">
          <div class="line-title">
            <div class="title-container">
              <div class="chinese-title">重要信息</div>
              <div class="english-title">IMPORIANI INFORMATION</div>
            </div>
          </div>
      <div class="y1">
        <div class="y2">
          <div class="t4_bg">
               

            <div class="y3" v-for="(itm,i) in notice" :key="i" @click="jump('/noteinfo?id=' + itm.id)">
              <div class="tit2">
                <div class="ico">
                  <span>{{ itm.idtit [cache('lang_config')]}}</span>
                </div>

                <span class="notice">{{ itm.paths.title}}</span>

              </div>
              <div class="ttt">

                <span class="ico2"> <i class="el-icon-arrow-right"></i> </span>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <br>
    <div class="hotzz cou_hotzz">

      <div class="line-title">
        <div class="title-container">
          <div class="chinese-title"> {{ $lang(50045) }}</div>
          <div class="english-title"> COUPON</div>
        </div>
      </div>

      <div class="inner">

        


        <div class="cou_list">
          <div class="row" v-for="(itm, i) in coupon" :key="'cc' + i" @click="get_cou(itm.id, i)">
            <div class="tc" v-if="itm.has || !is_login">
              <span v-if="!is_login"> {{ $lang(50123) }}</span>
              <span v-else>
                <span v-if="itm.has == 0">{{ $lang(50107) }}</span>


              </span>
            </div>

            <div class="box">
              <div class="l2">
                {{ itm.strs.reduce }}
                <span class="y" v-if="itm.type == 0">{{ $lang(48468) }}</span>
                <span class="y" v-if="itm.type == 1">%</span>


              </div>
              <div class="l22">
                <div class="l22t">
                  {{$lang(50045)}}
                </div >
                <div class="l22d">
 {{ itm.strs.desc }}
                </div>

              </div>
              <div class="l3">

                  {{ $lang(50107) }}


              </div>
            </div>


          </div>
        </div>
      </div>

    </div>


    <div class="coupon_list" v-if="0">
      <div class="coupon" v-for="(itm, i) in coupon " :key="'cc'+i">
        <div class="inner">
          <div class="yuan"> {{$lang(48468)}} </div>
          <div class="price">{{itm.strs.reduce}}</div>
          <div class="desc">
            <div class="tit1">{{$lang(50045)}}</div>
            <div class="tit2">
              <div v-if="itm.standard == 0">
                {{$lang(50108)}}
              </div>
              <div v-else>
                {{$lang(50058)}}{{itm.strs.standard}}{{$lang(50110)}}
              </div>
            </div>


          </div>

        </div>
        <div class="btn" v-bind:class="{has: itm.has }" @click="get_cou(itm.id, i)">
          <span v-if="!$store.state.is_login"> {{$lang(50123)}}</span>
          <span v-else>
            <span v-if="itm.has == 0">{{$lang(50107)}}</span>
            <span v-else>{{$lang(50126)}}</span>

          </span>

        </div>
      </div>
    </div>

    <div class="t5">
       <div class="line-title">
        <div class="title-container">
          <div class="chinese-title"> {{this.$lang('37414')}}</div>
          <div class="english-title"> RECOMMEND</div>
        </div>
      </div>

       
      <div class="tt6">
        <div class="bg" v-for="(itm,n) in article" :key="n" @click="jump('/noteinfo?id=' + itm.id)">
          <div class="cover">
            <img :src="itm.paths.cover" alt="">
          </div>
          <div class="title1">
            <div>
              {{ itm.paths.title}}
            </div>

            <div class="city_tag">
              {{ city_dis( itm.paths.city) }}
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import nav_list from './nav_list.vue';
export default {
  name: "index",
  data() {
    return {
      options:[

      ],

      pickerOptions: {
        disabledDate(time) {
          if (time.getTime() < new Date(new Date().toLocaleDateString()).getTime()) {
            return true
          }
          if (time.getTime() > (Date.now() + 1000 * 60 * 60 * 24 * 89)) {
            return true
          }
          return false
        },


      },
        set_out : '',
        destination : '',
        value2:'',
        radio:'1',
        notice: [],
        article: [],
        map : {
          start_id : 0,
          end_id : 0,
          date : '',
          time_division_type : 0,
        },
        adv: [],
        re : [],
        coupon : [],
        article_page : 1,
        hot : [],
        is_login : false,
        bannerProducts: [],
        recommendProducts: [],
    };
  },
  methods:{
    get_cou(id, i){
      if (!this.$store.state.is_login) {
        this.jump('/login')
      }
      this.get("/user/get_coupon_free", { id:id }).then((e) => {
        this.$message({
          type: 'success',
          message: this.$lang(50113)
        });
        this.coupon[i].has = 1


      });
    },
    f5(){
      this.get("/index_v4").then((e) => {
        if (e.stop == 'y' ) {
         
          try {
            this.$refs.wbsite.show()
          } catch (error) {
            
          }
          
        }
        this.notice = e.note
        this.article = e.article.data
        this.map = e.map
        this.date = e.map.date
        this.options = e.city;
        this.adv = e.adv;
        this.re = e.re;
        this.coupon = e.coupon;
        this.hot = e.hot
      });
    },
    loadShopRecommend() {
      this.get('/kkday_product/home_banner_recommend').then((e) => {
        this.recommendProducts = e && e.recommend_products ? e.recommend_products : [];
        this.bannerProducts = e && e.banner_products ? e.banner_products : [];
      }).catch(() => {
        this.recommendProducts = [];
        this.bannerProducts = [];
      });
    },
    chang_page(inc){
      if (inc== -1 && this.article_page == 1) {
        return 1
      }
      this.article_page += inc
      this.get("/index/article", { page: this.article_page }).then((e) => {

        this.article = e.article.data

      });
    },
    set_re(i){
      console.log(this.map)
      this.map.start_id =  this.re[i].start_id
      this.map.end_id =  this.re[i].end_id

      this.options.map((item) => {
        if (item.value == this.re[i].start_id) {
           this.map.start_city_key = item.key
        }
      })
        
      this.options.map((item) => {
        if (item.value == this.re[i].end_id) {
           this.map.end_city_key = item.key
        }
      })
      
      console.log(this.map)

      this.cache('home_map', this.map)
      this.cache('list_map', '')
      this.jump('search')
    },
    start_change(e){
      this.options.map((item) => {
        if (item.value == e[0]) {
           this.map.start_city_key = item.key
        }
      })
       
    },
    end_change(e){
      console.log(e)
      this.options.map((item) => {
        if (item.value == e[0]) {
           this.map.end_city_key = item.key
        }
      })
    },
    switch_se() {
      let temp = this.map.start_id
      this.map.start_id = this.map.end_id
      this.map.end_id = temp
       temp = this.map.start_city_key
       this.map.start_city_key = this.map.end_city_key
      this.map.end_city_key = temp
     



    },
    to_search(){
      if(!this.map.start_id){
        return  this.$message(this.$lang('37403'));
      }
      if (!this.map.end_id) {
        return  this.$message(this.$lang('37404'));
      }
      // console.log(this.map.end_id)
      // return
      this.cache('home_map', this.map)

      this.cache('list_map', '')
      console.log(this.cache('list_map'))

      this.jump('search')
    },
    getShopCover(item) {
      if (item && item.prod_img_url && item.prod_img_url.length) return item.prod_img_url[0];
      return require('../../../static/image/cover1.png');
    },
    getCategoryTitle(item) {
      return item && item.category && item.category.title ? item.category.title : '';
    },
    getLocationLabel(item) {
      if (item && item.city && item.city.title) return item.city.title;
      if (item && item.category && item.category.title) return item.category.title;
      return '日本目的地';
    },
    getShopSummary(item) {
      const raw = item && (item.introduction || item.sub_title || item.description || '');
      const text = String(raw).replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
      if (!text) return '精选票券与体验，适合加入你的日本行程。';
      return text.slice(0, 56);
    },
    formatShopPrice(item) {
      const price = item && item.b2c_min_price ? Number(item.b2c_min_price) : 0;
      if (!price) return '免费';
      return '¥' + price.toFixed(0) + ' 起';
    },

  },
  mounted(){
    document.title =  this.web_tit;
    this.f5()
    this.loadShopRecommend()
  },
  components:{  //注册
      nav_list,
  }

};
</script>
<style  scoped>
.t2  /deep/ .el-input__inner {
  border:1px solid #ffffff !important;
  background-color:#ffffff !important;
  color: #333;
  font-size: 16px;
  font-weight: 500;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.t2 /deep/ .el-input__inner:focus {
  box-shadow: 0 0 8px rgba(80, 162, 248, 0.3);
  border: 1px solid rgba(80, 162, 248, 0.5) !important;
}

.t2 /deep/ .el-radio__input.is-checked .el-radio__inner {
  border-color: #3956DA;
  background: #3956DA;
}

.t2 /deep/ .el-radio__input.is-checked+.el-radio__label {
  color: #3956DA;
}

.t2 /deep/ .el-cascader__dropdown {
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
</style> 
<style  lang="scss"  scoped>

.shop-home-block {
  width: 100%;
  padding: 10px 0 8px;
}

.shop-home-inner {
  width: 80vw;
  max-width: 1320px;
  margin: 0 auto;
}

.shop-more {
  color: #3956da;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.shop-more:hover {
  opacity: 0.72;
}

.shop-home-block .line-title {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 22px;
}

.ticket-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 22px;
}

.ticket-card {
  overflow: hidden;
  border-radius: 22px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.96) 0%, rgba(247, 250, 255, 0.98) 100%);
  box-shadow: 0 20px 44px rgba(15, 23, 42, 0.08);
  cursor: pointer;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.ticket-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 24px 52px rgba(15, 23, 42, 0.12);
}

.ticket-media {
  position: relative;
  height: 250px;
  overflow: hidden;
}

.ticket-media img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.ticket-badge {
  position: absolute;
  left: 18px;
  top: 18px;
  padding: 8px 14px;
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.62);
  backdrop-filter: blur(8px);
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
}

.ticket-body {
  padding: 22px 22px 20px;
}

.ticket-title {
  min-height: 70px;
  color: #182033;
  font-size: 25px;
  font-weight: 700;
  line-height: 1.38;
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.ticket-desc {
  min-height: 44px;
  margin-top: 12px;
  color: #667085;
  font-size: 14px;
  line-height: 1.7;
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.ticket-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 18px;
  padding-top: 18px;
  border-top: 1px solid rgba(148, 163, 184, 0.18);
}

.ticket-tag {
  display: inline-flex;
  align-items: center;
  min-height: 34px;
  padding: 0 14px;
  border-radius: 999px;
  background: #edf3ff;
  color: #3956da;
  font-size: 13px;
  font-weight: 600;
}

.ticket-price {
  color: #ef4444;
  font-size: 28px;
  font-weight: 700;
  white-space: nowrap;
}

.goods-shelf {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px;
}

.goods-card {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 20px;
  background: #fff;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.08);
  cursor: pointer;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.goods-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 22px 48px rgba(15, 23, 42, 0.12);
}

.goods-cover {
  height: 200px;
  background: #dbe7ff;
}

.goods-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.goods-copy {
  padding: 18px 20px;
  min-width: 0;
  flex: 1;
}

.goods-topline {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
}

.goods-category {
  color: #3956da;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.06em;
}

.goods-price {
  color: #ef4444;
  font-size: 22px;
  font-weight: 700;
  white-space: nowrap;
}

.goods-title {
  margin-top: 14px;
  color: #182033;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.38;
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.goods-summary {
  margin-top: 12px;
  color: #667085;
  font-size: 14px;
  line-height: 1.8;
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.coupon_list {
  padding-top: 2%;
  padding-left: 3%;
  display: flex;
  justify-content: space-between;
  width: 80vw;
  max-width: 80vw;
  flex-wrap: nowrap;
  margin: 0 auto;

  .coupon {
    border-style: none dotted none dotted;
    background: #145da3;
    height: 100px;
    min-width: 190px;
    border-radius: 5px;
    margin: auto;
    padding: 20px;
    display: flex;
    flex-direction: column;
    user-select: none;
    margin-bottom: 10px;

    .inner {
      display: flex;
      margin: auto;

      .yuan {
        font-size: 14px;
      }

      .price {
        font-size: 54px;
        margin-top: -11px;
      }

      .desc {
        min-width: 60px;
        font-size: 15px;
        margin-left: 5%;
      }
    }

    .btn {
      width: 60%;
      margin: auto;
      text-align: center;
      color: #145da3;
      background: #fff;
      line-height: 30px;
      height: 30px;
      cursor: pointer;
    }

    .has {
      background: rgb(179 179 179);
    }
  }
}

.t1 {
  display: flex;
  flex-direction: column;
  background-image: url("~@/../static/topbg.jpg");
  background-size: 100% 75vh;
  background-repeat: no-repeat;
  min-height: 100vh;
  position: relative;
 
}

.t2 {
  width: 100%;
  display: flex;
  align-items: center;
  padding-top: 100px;
  padding-bottom: 20px;

  .zzc1 {
    margin: 0 auto;
    background: #ffffffd1;
    border-radius: 16px;
    width: 60vw;
    padding: 35px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);

    .t2_tit {
      span {
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333;
        position: relative;
        display: inline-block;
        padding-bottom: 5px;
        
        &:after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 40px;
          height: 3px;
          background: #3956DA;
          border-radius: 2px;
        }

        img {
          vertical-align: middle;
          margin-right: 3%;
        }
      }
    }

    .p2 {
      margin-top: 4%;
      display: flex;
      align-items: flex-end;
      gap: 0;
      
      .l100 {
         border-radius: 8px 0 0 8px;
      }
      .l101 {
         border-radius: 0 8px 8px 0;
      }
       .switch-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: transform 0.3s ease;
          margin: 0 8px 8px 8px;
          align-self: flex-end;
          
          &:hover {
            transform: scale(1.1);
          }
          
          img {
            display: inline-block;
            width: 36px;
            height: 36px;
          }
        }
      .l1 {
        transition: all 0.3s ease;
        display: flex;
        flex-direction: column;
        
        &:hover {
          transform: scale(1.02);
        }
        
        .tit {
          font-size: 13px;
          color: #666;
          margin-bottom: 8px;
          font-weight: 500;
          padding-left: 20px;
          white-space: nowrap;
        }

        .ttt2 {
          display: flex;
          align-items: center;
          
          .ipt {
            width: 100%;
            min-width: 120px;
            padding: 5px 10px;
            background-color: #fff;
            border-radius: 5px;
            text-align: left;
          }
        }
      }
      }

      .l111 {
        background: #ffffff;
      }

      .llxx {
        flex: 0 0 24%;
        margin-left: 10px;
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        
        .tit {
          font-size: 13px;
          color: #666;
          margin-bottom: 8px;
          font-weight: 500;
          padding-left: 20px;
          white-space: nowrap;
        }

        .ttt2 {
          .ipt {
            width: 100%;
            min-width: 120px;
            padding: 5px 10px;
            background-color: #fff;
            border-radius: 5px;
            text-align: left;
          }
        }
      }

      .llzz {
        flex: 0 0 20%;
        max-width: 120px;
        margin-left: 10px;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        .zdzxxzcxz {
          cursor: pointer;
          // padding: 5px 0px;
          display: inline-block;
          height: 50px;
          line-height: 50px;
          border-radius: 12px;
          background: linear-gradient(135deg, #6A99F4 0%, #2C61CD 100%);
          color: #fff;
          font-size: 18px;
          font-weight: 500;
          text-align: center;
          border: 1px solid #6A99F4;
          transition: all 0.3s ease;
          
          &:hover {
            transform: translateY(-2px);
            box-shadow: 0px 6px 20px rgba(57, 90, 246, 0.5);
          }
          
          i {
            margin-right: 5px;
            font-size: 20px;
          }
        }
      }
    }

    .p3 {
      margin-top: 3%;
      display: flex;

      .ll1 {
        display: flex;
        flex: 0 0 66%;

        .li1_tit {
          flex: 0 0 16%;
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          white-space: nowrap;
          margin-right: 10px;
        }

        .rad {
          .span1 {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
          }

          .radio {
            margin-top: 1.5%;
          }
        }
      }

      .a_sear {
        text-decoration: none;
        margin-right: 3.6%;
      }

      .ll2 {
        background: #eb5100;
        flex: 0 0 29.6%;
        height: 60px;
        border-radius: 5px;
        display: flex;
        margin-bottom: 2.5%;

        .btn {
          background: #eb5100;
          color: #fff;
          width: 100%;
          font-size: 18px;
        }

        .soc {
          font-size: 18px;
          letter-spacing: 10px;
        }

        .a1 {
          display: flex;
          margin-left: 35%;
          margin-top: 4.5%;
          margin-right: 50px;
        }

        .a2 {
          img {
            margin: 0 auto;
            margin-top: 80%;
          }
        }
      }
    }

    .p4 {
      display: flex;
      margin-top: 2%;
      width: 90%;
      margin: auto;
       border-radius: 10px;
      background-color: #fff;
      justify-content: space-between;
      overflow: hidden;
      padding: 1px;
      border: 1px solid #fff;
      box-shadow: 0px 0px 14px 4px #fff;
      .p4_list {
        flex: 24%;
        margin: auto 1px ;
        height: 40px;
        line-height: 40px;
        background-color: #457BDF;
        text-align: center;
        align-items: center;
        font-size: 14px;
        color: #fff; 
				&:hover { 
					transform: translateY(-2px);
				
				}
         &:first-child {
          border-radius: 10px 0 0 10px;
        }
        &:last-child {
          border-radius: 0 10px 10px 0;
          
        }
      }
      
    }
  }



.t3 {
  margin: 30px auto;
  margin-top: 0;
  display: flex;
  width: 60vw;
  padding: 0px 30px;
  height: 130px;
  flex-direction: row;
  justify-content: space-between;
  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #ffffffd1;
  .tt3:hover {
    transform: translateY(-5px);
  }
  .tt3 {
    flex: 0 0 25%;
    height: 130px;
    transition: all 0.3s ease;
    .j1 {
      max-width: 250px;
      width: 95%;
      margin: auto;
      height: 130px;
      display: flex;
      flex-direction: column;
      justify-content: center;

      img {
        display: block;
        width: 66px;
        margin: auto;
      }

      .txt {
        height: 34px;
        line-height: 40px;
        text-align: center;
        font-size: 16px;
        font-family: Microsoft YaHei;
        color: #696969;
      }
    }

    .j2 {
      width: 250px;
      height: 130px;

      img {
        width: 56px;
        height: 69px;
        margin-top: 14px;
        margin-left: 95px;
      }

      span {
        width: 72px;
        height: 18px;
        margin-top: 14px;
        margin-left: 90px;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: bold;
      }
    }

    .j3 {
      width: 250px;
      height: 130px;

      img {
        width: 56px;
        height: 69px;
        margin-top: 14px;
        margin-left: 95px;
      }

      span {
        width: 72px;
        height: 18px;
        margin-top: 14px;
        margin-left: 90px;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: bold;
      }
    }

    .j4 {
      width: 250px;
      height: 130px;

      img {
        width: 56px;
        height: 69px;
        margin-top: 14px;
        margin-left: 95px;
      }

      span {
        width: 72px;
        height: 18px;
        margin-top: 14px;
        margin-left: 90px;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: bold;
      }
    }
  }
}

@media (max-width: 1280px) {
  .shop-home-inner {
    width: calc(100vw - 64px);
  }

  .ticket-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .goods-shelf {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .goods-card {
    /* no inner grid to adjust anymore */
  }
}

@media (max-width: 960px) {
  .ticket-grid,
  .goods-shelf {
    grid-template-columns: 1fr;
  }

  .goods-cover {
    min-height: 220px;
  }
}

.t4 {
  .y1 {
    width: calc(60vw + 60px);
    margin: 0 auto;
    display: flex;

    .y2 {
      margin: 0 auto;
      width: 100%;
      min-height: 100px;
      border-radius: 6px;
      // box-shadow: 0 8px 25px rgba(0, 0, 0, 0.06);
      border: 1px solid #e0e0e0;
      background-color: #ffffff;
      overflow: hidden;

      .t4_bg {
        padding: 30px;
        display: flex;
        flex-direction: column;

        .tit {
          line-height: 50px;
          border-radius: 5px;
          color: #3956DA;
          font-size: 20px;
          font-weight: bold;
          position: relative;
          display: inline-block;
          margin-bottom: 10px;
          
          &:after {
            content: '';
            position: absolute;
            bottom: 10px;
            left: 0;
            width: 40px;
            height: 3px;
            background: #3956DA;
            border-radius: 2px;
          }
        }

        .y3 {
          margin-top: 1%;
          display: flex;
          border-bottom: 1px solid #e0e0e0;
          cursor: pointer;
          padding: 8px 0;
          transition: all 0.3s ease;
          
          &:hover {
          
            transform: translateX(5px);
          }

          .tit2 {
            width: 58vw;
            display: flex;
            margin-bottom: 1%;
            align-items: center;

            .notice {
              font-size: 16px;
              font-family: Microsoft YaHei;
              // font-weight: 500;
              color: #333;
              display: flex;
              transition: color 0.3s ease;
              
              &:hover {
                color: #3956DA;
              }
            }

            .ico {
              border-radius: 6px;
              background-color: rgba(232, 90, 68, 0.1);
              color: #E85A44;
              min-width: 80px;
              height: 30px;
              line-height: 30px;
              margin-right: 15px;
              text-align: center;
              padding: 0 5px;

              span {
                text-align: center;
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 600;
              }
            }
          }

          .ttt {
            .li1 {
              font-size: 22px;
              font-family: Microsoft YaHei;
              font-weight: 400;
            }
          }

          .ico2 {
            width: 12px;
            height: 20px;
            font-size: 22px;
            font-family: Microsoft YaHei;
            font-weight: 400;
          
            margin-left: 20px;
            transition: transform 0.3s ease;
            
            &:hover {
              transform: translateX(3px);
            }
          }
        }
      }
    }
  }
}

.t5 {
  padding: 50px 0px;

  .tt5 {
    margin: 0 auto;
    padding-top: 30px;

    .titt {
      display: flex;

      span {
        margin: 0 auto;
        font-size: 22px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333;
        position: relative;
        padding-bottom: 10px;
        
        &:after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 40px;
          height: 3px;
          background: #3956DA;
          border-radius: 2px;
        }
      }
    }

    .lli2 {
      display: flex;
      font-size: 32px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #373737;

      .up {
        background: #3956DA;
        border-radius: 8px;
        margin: 0 auto;
        width: 180px;
        height: 50px;
        display: flex;
        cursor: pointer;
        transition: all 0.3s ease;
        
        &:hover {
          background: #2945c7;
          transform: translateY(-2px);
          box-shadow: 0 5px 15px rgba(57, 86, 218, 0.2);
        }

        span {
          margin: 0 auto;
          margin-top: 7%;
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #FDFDFD;
        }
      }
    }
  }

  .tt6 {
    margin: 0 auto;
    width: 73.5vw;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: center;

    .bg {
      border: 1px solid #eee;
      flex: 0 0 24%;
      cursor: pointer;
      margin-top: 20px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
      border-radius: 10px;
      overflow: hidden;
      transition: all 0.3s ease;
      position: relative;
      &:hover {
        transform: translateY(-5px);
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
      }

      .cover {
        overflow: hidden;
        
        img {
          width: 100%;
          height: 241px;
          transition: transform 0.5s ease;
          
          &:hover {
            transform: scale(1.05);
          }
        }
      }
       .city_tag {
          color: #fff;
          background-color: #3956DA;
          font-size: 14px;
          
          padding: 3px 8px;
          border-radius: 4px;
          position: absolute;
          top: 10px;
          right: 10px;
        }
      .title1 {
        min-height: 50px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        padding: 0 15px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        
       
      }
    }
  }
}

.disb {
  background: rgb(138, 138, 138) !important;
  cursor: not-allowed !important;
}

/* Line Title Component */
.line-title {
  display: flex;
  align-items: center;
  text-align: center;
  margin: 50px auto;
  width: 60%;
  &::before,
  &::after {
    content: '';
    flex: 1;
    height: 1px;
    width: 50%;
    background: linear-gradient(90deg, transparent, #ddd, transparent);
  }
  
  .title-container {
    padding: 0 40px;
    background: #fff;
    
    .chinese-title {
      font-size: 18px;
      font-weight: 600;
      color: #2c3e50;
      margin-bottom: 8px;
      letter-spacing: 2px;
    }
    
    .english-title {
      font-size: 12px;
      color: #7f8c8d;
      font-family: 'Arial', sans-serif;
      text-transform: uppercase;
      letter-spacing: 3px;
    }
  }
}

/* Simpler version */
.line-title-simple {
  position: relative;
  text-align: center;
  margin: 40px 0;
  
  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    height: 1px;
    background: #e0e0e0;
    z-index: 0;
  }
  
  .title-content {
    display: inline-block;
    background: #fff;
    padding: 0 30px;
    position: relative;
    z-index: 1;
    
    .chinese {
      font-size: 24px;
      font-weight: bold;
      color: #333;
      display: block;
    }
    
    .english {
      font-size: 14px;
      color: #666;
      display: block;
      margin-top: 4px;
    }
  }
}

.sybt {
  text-align: center;
  padding: 20px 0;
   font-size: 16px;
   font-weight: 500;
  display: block;
  padding-top: 40px;
}







.cou_hotzz {
  
   padding: 20px 0;
   .tit {
    color: #0464dd;
   }
}
.zcxzcxz {
  background: none !important;
}
.hotzz {
  background-color: #fff;
  border-radius: 16px;
  margin: auto;
  margin-top: 40px;
  width: calc(60vw + 60px);
  max-width: 1200px;
  min-width: 320px;
  flex-direction: row;
  justify-content: space-between;
  transition: all 0.3s ease;

  // 响应式容器宽度
  @media (max-width: 1400px) {
    width: calc(70vw + 40px);
  }

  @media (max-width: 1000px) {
    width: calc(80vw + 20px);
  }

  @media (max-width: 600px) {
    width: calc(95vw + 10px);
  }
  
 

  .tit {
    height: 24px;
    font-weight: bold;
    line-height: 24px;
    font-size: 20px;
    padding-bottom: 20px;
  
    color: #333;
    position: relative;
  
    text-align: center;
     
  }

  .lab {

    font-size: 14px;
    color: #9e9e9e;
  }

  .rrr {
    flex: 0 0 60%;
    margin-left: 20px;
  }

  .car_ll,
  .car_rr {
    font-weight: bold;
    font-size: 16px;
  }

  .car_rr {
    padding-left: 10px;
  }

  .sreach {
    margin-top: 30px;
    background-color: #50A2F8;
    color: #fff;
    height: 70px;
    line-height: 70px;
    text-align: center;
    border-radius: 30px;
    box-shadow: #395AF677 0 2px 6px 0;

  }

  select {
    font-weight: bold;
    font-size: 16px;
    border: none;

    padding: 5px;
  }

  .dada {
    padding-bottom: 10px;
    font-size: 12px;
  }

  .hist {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .qow {
      background-image: url("~@/../static/v3/pr1.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      height: 240px;
      margin-bottom: 15px;
      transition: all 0.3s ease;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      // border-radius: 12px;
      
      /* Black overlay */
      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.3);
        transition: transform 0.4s ease;
        transform-origin: left;
        transform: scaleX(1);
        z-index: 1;
      }
      
      &:hover::before {
        transform: scaleX(0);
      }
      
      /* Centered content */
      .top,
      .bott {
        position: absolute;
        left: 0;
        right: 0;
        z-index: 2;
        transition: all 0.3s ease;
      }
      
      .top {
        top: 50%;
        transform: translateY(-50%);
        text-align: center;
        color: white;
        
        .start,
        .end {
          font-size: 24px;
          font-weight: bold;
          margin: 10px 0;
          padding: 0 10px;
          text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);
        }
        
      }
      
      .bott {
        top: 55%;
        text-align: center;
          color: white;
          padding-top: 10px;
         
      }
      
      &:hover {
        transform: translateY(-5px);
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
      }

      .top {
        display: flex;
        justify-content: center;
        width: 90%;
        margin: auto;
        font-size: 14px;
        padding: 5px 0;
        white-space: nowrap;
        
        .start, .end {
          font-weight: 500;
          color: #333;
          
        }
      
      }

       
    
    }
    .qow-0 {
      flex: 0 0 57%;
    }
    .qow-1{
       flex: 0 0 40%;
    }
    .qow-2 {
      flex: 0 0 50%;
    }
    .qow-3{
       flex: 0 0 47%;
    }
    
    /* Enhanced image card overlay */
    .qow::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.25);
      transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
      transform-origin: left;
      transform: scaleX(1);
      z-index: 1;
    }
    
    .qow:hover::before {
      transform: scaleX(0);
    }
    
    /* Center content overlay */
    .qow .top {
      position: absolute;
      left: 0;
      right: 0;
      color: white;
      z-index: 2;
      transition: all 0.3s ease;
    }
    
    .qow .top {
      top: 50%;
      transform: translateY(-50%);
      text-align: center;
      
      .start,
      .end {
        font-size: 28px;
        font-weight: bold;
        margin: 8px 0;
        color: white;
        text-shadow: 0 2px 8px rgba(0, 0, 0, 0.8);
      }
      
      .mmd {
         
        align-items: center;
        justify-content: center;
        gap: 8px;
        margin: 15px 0;
        min-width: 50%;
        
        .zwf {
          font-size: 16px;
          color: white;
          opacity: 0.9;
        }
        
        img {
            width: 100%;
        
          filter: brightness(0) invert(1);
        }
      }
    }
    
     
  }

  .car_list {
    display: flex;
    max-width: 100%;
    overflow-x: scroll;


  }

  .goods_list {
    .row {
      flex: 0 0 30%;
      height: 14vh;
      position: relative;

      image {
        width: 100%;
      }
    }

    .ztt {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;

      text-align: center;
      padding: 5px 0;
      font-size: 13px;
      background-color: #00000017;
      backdrop-filter: blur(3px);
      color: #fff;
    }
  }




  .node_list {
    .row {
      background-image: url("~@/../static/v3/line.png");
      background-repeat: no-repeat;
      background-size: contain;
      display: flex;
      align-items: center;
      padding: 10px 0;

      .tag {
        flex: 0 0 10%;
        text-align: center;
        font-size: 14px;
        color: #E85A44;
      }

      .txt {
        color: #3F3F3F;
        flex: 0 0 80%;
        font-size: 13px;
        overflow: hidden;
        height: 20px;
      }

      .r {
        flex: 0 0 10%;
        text-align: right;

        image {
          width: 50%;
        }
      }
    }
  }

  .cou_list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 12px;

    .row {
      margin: 12px 0;
      background-image: url("~@/../static/v3/cou.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      height: 90px;
      flex: 0 0 calc(25% - 9px);
      min-width: 200px;
      max-width: 280px;
      transition: all 0.3s ease;
      cursor: pointer;

      // 响应式设计
      @media (max-width: 1400px) {
        flex: 0 0 calc(33.333% - 8px);
      }

      @media (max-width: 1000px) {
        flex: 0 0 calc(50% - 6px);
      }

      @media (max-width: 600px) {
        flex: 0 0 100%;
        max-width: none;
      }
      
      &:hover {
        transform: translateY(-5px);
        filter: brightness(1.03);
      }

      .tc {
        height: 160px;
        line-height: 160px;
        text-align: center;
        width: 44%;
        background-color: rgba(0, 0, 0, 0.6);
        position: absolute;
        display: none;
        border-radius: 8px;
        color: #fff;
        font-weight: 500;
      }

      .box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 90px;
        
        .l2 {
          flex: 0 0 40%;
          text-align: center;
          font-size: 50px;
          color: #3956DA;
          text-shadow: 0 2px 4px rgba(57, 86, 218, 0.2);
          
          .y {
            font-size: 20px;
            height: 30px;
            display: inline-block;
            vertical-align: super;
            margin-top: -10px;
          }
        }

        .l22 {
          font-size: 8px;
          flex: 0 0 30%;

          .l22t {
            font-size: 20px;
            text-align: center;
            font-weight: bold;
            padding-bottom: 8px;
            color: #333;
          }

          .l22d {
            background-color: #3956DA;
            color: #fff;
            padding: 4px 10px;
            text-align: center;
            border-radius: 4px;
            font-size: 12px;
            font-weight: 500;
            box-shadow: 0 2px 6px rgba(57, 86, 218, 0.2);
          }
        }

        .l3 {
          flex: 0 0 17%;
          writing-mode: tb-rl;
          color: #fff;
          font-size: 16px;
          text-align: center;
          padding-right: 5%;
          padding-top: 2px;
          font-weight: 500;
          letter-spacing: 1px;
        }
      }
    }
  }


  .scenic_list {
    .row {
      flex: 0 0 40%;
      height: 20vh;
      position: relative;
 
    }

    .ztt {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;

      text-align: center;
      padding: 5px 0;
      font-size: 13px;
      background-color: #00000017;
      backdrop-filter: blur(3px);
      color: #fff;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue